import { render, staticRenderFns } from "./courseListEdit.vue?vue&type=template&id=da0492b2&scoped=true"
import script from "./courseListEdit.vue?vue&type=script&lang=js"
export * from "./courseListEdit.vue?vue&type=script&lang=js"
import style0 from "./courseListEdit.vue?vue&type=style&index=0&id=da0492b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0492b2",
  null
  
)

export default component.exports